<template>
    <div class="create-company-page page" style="max-width: 600px">
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <h4 class="page-title">Create User</h4>
                </div>
            </div>
        </div>
        <div class="card card-body mt-0">
            <user/>
        </div>
    </div>
</template>

<script>
    import User from "@/components/main/User";

    export default {
        components: {
            User
        }
    }
</script>

<style scoped>

</style>
